<template>
  <div class="card" style="width: 25rem" v-if="this.quantity>0" > 
    <h3>{{ nftTitle }} </h3>
    <form @submit.prevent="buyNFT">
      <img
      class="card-img-top"
      :src="nftImg"
      style="height: 20rem"
      height="320"
    />
    <p class="card-text">Price : {{ nftPrice }} BTC </p>
    <br>
    <button class="button"> BUY </button>
    </form>
  </div>
</template>

<script>
import AxiosService from "../services/AxiosService.js";
import { app } from "../main.js";

export default {
  inject: ["listedNFTs"], 
  emits: ["update-wallet"],
  props: ["nftId", "nftTitle", "nftImg", "nftPrice"],

  mounted() {
    this.getResult();
  },
  data() {
    return {
      quantity: 1,
      
    };
  },
  methods: {
    buyNFT() {
      if (app.config.globalProperties.$wallet < this.nftPrice) {
        alert("You don't have enough BTC in your wallet. Please mint more BTC");
      } else {
        this.$emit("update-wallet", this.nftPrice*-1);  
        AxiosService.postPreRegis({
          nftId: this.nftId,
          nftTitle: this.nftTitle,
          nftImg: this.nftImg,
          nftPrice: this.nftPrice,
          user: app.config.globalProperties.$displayName,
          // bitcoinWallet: app.config.globalProperties.$wallet,

        })
        .then((response) => {
          console.log(response.status); 
        })
        .catch((error) => {
          console.log(error);
        });
        this.quantity = 0;
        alert("Congrats! Your NFT is now in your Collection");
      }
       
  },
  getResult() {
    AxiosService.getPreRegis()
      .then((response) => {
        const data = response.data;
        for (const frbId in data) {
          if(data[frbId].nftId === this.nftId){
            this.quantity = 0;
          }
        } 
      })
      .catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>

<style scoped>

.button {
  background-color: #4caf50;
  border: 3p;
  border-color: black;
  color:white;
  font-family:Arial, Helvetica, sans-serif;
  border-radius: 3px;
  font-size: 1.3rem;

}

.button:hover {
  background-color: white;
  border: 3p;
  color:#4caf50;
  font-family:Arial, Helvetica, sans-serif;
  border-radius: 3px;
  font-size: 1.3rem;
}

.card {
  box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
  height: 29rem;
  display: inline-block;
  width: 350px;
  text-align: center;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 5px gray;
  font-family: Arial, Helvetica, sans-serif;
}

p {
  display: inline-block;
  padding-left: 25px;
  font-family: Arial, Helvetica, sans-serif;
}


</style>